/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/keyword-spacing */
/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-throw-literal */
/* eslint-disable no-console */
/* eslint-disable no-continue */
/* eslint-disable no-await-in-loop */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-void */
/* eslint-disable no-restricted-syntax */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable max-len */
/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable object-curly-newline */
import React from "react";

import { useNavigate } from "react-router-dom";

import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { ReactSlickSetting } from "../ReactSlickSettings";
import SompoCategoryButton from "./SompoCategoryButton";
import { TRAINING_TYPE_CAREER, TRAINING_TYPE_CURRICULUM } from "../../Constants";
import SompoSearchMode, { SompoSearchModeValue } from "../mode/SompoSearchMode";
import { useScreenSize } from "../Theme";
import { CATEGORY_ID_CAREERS, CATEGORY_ID_CURRICULUMS, useCategoryTree, CategoryTree, CATEGORY_TREE_DEFAULT } from "../../logic/hook/useCategories";
import { CategoryTreeItem } from "../../logic/api/CategoryTreeService";
import { shapingString } from "../../logic/utility/textUtil";
import { showErrorMessage } from "../../logic/hook/useDialogStateHelper";
import SompoContext from "../../logic/context/SompoContext";
import SompoLoading from "../loading/SompoLoading";

export interface CategoryProps {
    border?: boolean;
    setDrawerOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const fetchIcon = async (fileName: string): Promise<string> =>
    // 設定ファイルをfetch
    fetch(`./category/${fileName}`, {
        method: "GET",
        headers: [["Cache-Control", "no-cache"]],
    })
        .then(async (response: Response) => {
            // 200：OK以外は何もしない
            if (!response.ok) {
                return ""; // dataUrl;
            }

            // 2. Data URLに変換
            // 2.1. レスポンスをBlobに変換
            const blob = await response.blob();

            const imageReader = new FileReader();
            // 2.2. Blob → Data URLへの変換を実施
            imageReader.readAsDataURL(blob);

            const dataUrl: string = await new Promise((resolve) => {
                // Blob → Data URLへの変換処理
                imageReader.onload = () => {
                    // 読み込み結果 = Data URL
                    const _dataUrl = imageReader.result as string;
                    resolve(_dataUrl);
                };
            });

            // 2.3. Data URLを返す
            return dataUrl;
        })
        .catch((error: any) => {
            // 例外処理です。何もしない
            return "";
        });

const Category = (props: CategoryProps) => {
    const navigate = useNavigate();
    const { desktop } = useScreenSize();
    const { fetchCategoryTree } = useCategoryTree();

    const [images, setImages] = React.useState<{ [categoryname: string]: string }>({});
    const getBase64Image = (name: string) => images[name];

    const [searchMode, setSearchMode] = React.useState<SompoSearchModeValue>(TRAINING_TYPE_CAREER);
    const handleSearchModeChanged = (selected: SompoSearchModeValue) => {
        setSearchMode(selected);
    };

    // カテゴリ関連
    const [categories, setCategories] = React.useState<CategoryTree>(CATEGORY_TREE_DEFAULT);
    const { getChildren, showCurriculums: showCurriculumsFn } = categories;
    const showCurriculums = showCurriculumsFn();
    let rootId: string;
    switch (searchMode) {
        case TRAINING_TYPE_CURRICULUM:
            rootId = CATEGORY_ID_CURRICULUMS;
            break;
        case TRAINING_TYPE_CAREER:
        default:
            rootId = CATEGORY_ID_CAREERS;
            break;
    }
    const mainCategories = getChildren(rootId);

    const sompoContext = React.useContext(SompoContext);
    const clearSearchContext = () => sompoContext.setSearchText("");
    const trainingListNavigate = (item: CategoryTreeItem) => {
        // console.log("Category: navigate", item);
        clearSearchContext();
        navigate("/trainingList", { state: { categoryId: item.id, parentCategoryId: item.parentId, searchMode } });
        if (props.setDrawerOpen) {
            props.setDrawerOpen(false);
        }
    };

    React.useEffect(() => {
        const _fetch = async () => {
            // カテゴリアイコン
            const newImages: { [categoryname: string]: string } = {};
            await fetch("./category/categories.json", {
                method: "GET",
                headers: [
                    ["Content-Type", "application/json;charset=UTF-8"],
                    ["Cache-Control", "no-cache"],
                ],
            })
                .then(async (response: Response) => {
                    const json = await response.json();

                    const settings = json as unknown as { [categoryname: string]: string };

                    for (const categoryName of Object.keys(settings)) {
                        const iconFileName = settings[categoryName];
                        if (!iconFileName) continue;
                        const dataURL = await fetchIcon(iconFileName);
                        newImages[categoryName] = dataURL;
                    }
                })
                .catch((error: any) => {
                    console.error(error);
                    showErrorMessage({ message: "カテゴリアイコンの取得に失敗しました。", error });
                });

            // カテゴリ
            const _categories = await fetchCategoryTree();

            // Set states.
            setImages(newImages);
            setCategories(_categories);
        };
        void _fetch();
    }, []);

    return desktop ? (
        <Box
            sx={{
                width: "100%",
                height: "auto",
                minHeight: "200px",
            }}
        >
            <Grid container direction={"row"} flexWrap={"nowrap"} alignItems={"center"} columnGap={2} sx={{ mb: 3 }}>
                <Typography variant="h3">{"カテゴリから探す"}</Typography>
                {showCurriculums && (
                    <>
                        <Typography>{"検索対象："}</Typography>
                        <SompoSearchMode searchMode={searchMode} onChangeSelected={handleSearchModeChanged} />
                    </>
                )}
            </Grid>

            {/* fetchが終わるまでローディングアイコンを表示 */}
            {sompoContext.loading ? (
                <SompoLoading position="relative" />
            ) : (
                <>
                    {(mainCategories || []).map((mainCategory, indexMain) => {
                        if (!(mainCategory.children || []).length) return;
                        return (
                            <React.Fragment key={`Category-Main-${indexMain}`}>
                                <Typography variant="h4" sx={{ mb: 1, wordBreak: "break-all" }}>
                                    {`${mainCategory.text}`}
                                </Typography>
                                <Box sx={{ width: "100%", height: "120px", margin: "0 auto" }}>
                                    <Slider {...ReactSlickSetting}>
                                        {mainCategory.children!.map((subCategory, indexSub) => {
                                            if (!subCategory.count && !(subCategory.children || []).length) return;
                                            return (
                                                <SompoCategoryButton
                                                    key={`Category-Sub-${indexMain}-${indexSub}`}
                                                    name={subCategory.text}
                                                    border={props.border}
                                                    trainingListNavigate={() => trainingListNavigate(subCategory)}
                                                    icon={getBase64Image(subCategory.text) || ""}
                                                />
                                            );
                                        })}
                                    </Slider>
                                </Box>
                            </React.Fragment>
                        );
                    })}
                </>
            )}
        </Box>
    ) : (
        <Box sx={{ width: "100%" }}>
            <Grid
                container
                direction={"column"}
                sx={{ px: 2, py: 1, width: "100%", borderTop: "7px solid #f5f6f6", borderBottom: "3px solid #f5f6f6" }}
            >
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    {"カテゴリから探す"}
                </Typography>
                {showCurriculums && (
                    <Grid item container direction={"row"} flexWrap={"nowrap"} columnGap={1} alignItems={"center"}>
                        <Typography>{"検索対象："}</Typography>
                        <SompoSearchMode searchMode={searchMode} onChangeSelected={handleSearchModeChanged} />
                    </Grid>
                )}
            </Grid>
            {/* fetchが終わるまでローディングアイコンを表示 */}
            {sompoContext.loading ? (
                <SompoLoading position="relative" />
            ) : (
                <>
                    {(mainCategories || []).map((mainCategory, indexMain) => {
                        if (!(mainCategory.children || []).length) return;
                        return (
                            <React.Fragment key={indexMain}>
                                <ListItem sx={{ p: 2 }}>
                                    <Typography variant="body1" sx={{ wordBreak: "break-all" }}>{`${mainCategory.text}`}</Typography>
                                </ListItem>
                                <Divider sx={{ width: "90%", m: "0 auto" }} />

                                {mainCategory.children!.map((subCategory, indexSub) => {
                                    if (!subCategory.count && !(subCategory.children || []).length) return;
                                    return (
                                        <ListItemButton key={indexSub} sx={{ p: 2 }} onClick={() => trainingListNavigate(subCategory)}>
                                            <ListItemAvatar>
                                                <Avatar src={getBase64Image(subCategory.text)} sx={{ bgcolor: "#D0D8E6" }}>
                                                    {" "}
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText primary={<Typography variant="body1">{shapingString(subCategory.text, 10)}</Typography>} />
                                            <KeyboardArrowRightIcon />
                                        </ListItemButton>
                                    );
                                })}
                            </React.Fragment>
                        );
                    })}
                </>
            )}
        </Box>
    );
};

export default Category;
